/* The client half of the asset base (3 Aug 2026, docs/cdn-migration-plan.md).

   The bucket host is per-environment, so it cannot be baked into the bundle at
   build time: the image is built once in CI and then deployed, and a value
   compiled in would follow it everywhere including a local build. The server
   writes it into the shell head (server/shellhead.ts) and this reads it back,
   once, at module load.

   Absent means empty, which is what Vite serves in dev: the paths stay
   relative, Vite proxies /images to Fastify, and the dev route there answers
   from disk or forwards to the bucket. */
import { assetImg, assetSrcSet, assetUrl } from "../shared/assets.js";

const BASE =
  typeof document === "undefined"
    ? ""
    : (document.querySelector('meta[name="asset-base"]')?.getAttribute("content") ?? "");

export const assetsBase = (): string => BASE;

/** A stored path as the browser should ask for it. */
export const artUrl = (stored: string): string => assetUrl(BASE, stored);

/** Both halves of an <img>, spread onto the element: {...artImg(path)}. */
export const artImg = (stored: string): { src: string; srcSet?: string } => assetImg(BASE, stored);

/* For the places that genuinely cannot be an <img>: a CSS background takes no
   srcset, so it takes the original and that is the end of it. Anything on a
   compact surface should be an <img> instead, which is why the Crossfire tile
   stopped being a background on 3 Aug 2026. */
export const artCss = (stored: string): string => `url(${artUrl(stored)})`;

export { assetSrcSet };
